interface Props {
  keyFindings: string[];
  recommendations: string[];
}

export default function FindingsCallouts({
  keyFindings,
  recommendations,
}: Props) {
  if (keyFindings.length === 0 && recommendations.length === 0) return null;
  // Inner content only; SectionShell supplies the `findings` anchor + eyebrow.
  return (
    <>
      {keyFindings.length > 0 && (
        <div className="POST__ANALYSIS__callout callout-info">
          <p className="POST__ANALYSIS__callout__title">Key findings</p>
          <ul>
            {keyFindings.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        </div>
      )}
      {recommendations.length > 0 && (
        <div className="POST__ANALYSIS__callout callout-success">
          <p className="POST__ANALYSIS__callout__title">Recommendations</p>
          <ul>
            {recommendations.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
